import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ACL } from "../../../components/acl";
import { ADMIN, SUPERADMIN } from "../../../constants/roles";
import { useNavigate } from "react-router-dom";
import * as actions from "../../../actions";
import { getValueFromNestedObject } from "../../../util/operations/helper";
import { IoIosCall } from "react-icons/io";
function Sidebar({company_id, companyDetails, type }) {
  const [isZuperPayEnabled, setIsZuperPayEnabled] = useState(false);
  const [isZuperConnectEnabled, setIsZuperConnectEnabled] = useState(false);
  const currentPolicy = useSelector((state) => state.company.policy);
  const companyModules = useSelector((state) => state.company.modules);
  const dispatch = useDispatch();
  const styleLink = (linkType) =>
    type === linkType
      ? "bg-indigo-50 text-indigo-600"
      : "text-gray-500 hover:bg-gray-100";
  const styleSvg = (linkType) =>
    type === linkType
      ? "text-indigo-500"
      : "text-gray-400 group-hover/item:text-gray-500";

  const navigate = useNavigate();
  const pageHandling = (type) => {
    navigate(`/customers/${companyDetails?.company_uid || company_id}/${type}`);
  };

  useEffect(() => {
    if (companyDetails?.company_uid && !currentPolicy) dispatch(actions.GETCOMPANYPOLICY_REQ({ company_uid: companyDetails?.company_uid, no_loader: true }));
    if (companyDetails?.company_uid && !companyModules?.data) {
      dispatch(actions.GETMODULES_REQ({ company_uid: companyDetails?.company_uid }));
    };
  }, [companyDetails?.company_uid]);

  useEffect(() => {
    if (currentPolicy) {
      setIsZuperPayEnabled(getValueFromNestedObject(currentPolicy, 'zuper_pay.is_enabled'));
    }
  }, [currentPolicy])

  useEffect(() => {
    if (companyModules?.data) {
      const hasConnectModule = companyModules.data.some(
        (m) => m.module.module_key === "CONNECT"
      );
      setIsZuperConnectEnabled(hasConnectModule);
    }
  }, [companyModules])

  return (
    <ul className="space-y-2 [&>li]:cursor-pointer">
      <li>
        <span
          onClick={() => pageHandling(`details`)}
          className={`${styleLink(
            "details"
          )} w-full group/item inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
        >
          <svg
            className={`${styleSvg(
              "details"
            )} group-hover/item:text-gray-500 -ml-0.5 mr-2 h-5 w-5`}
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A9.957 9.957 0 0010 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 00-13.074.003z"></path>
          </svg>
          <span>Account Details</span>
        </span>
      </li>
      <li>
        <span
          onClick={() => pageHandling(`users`)}
          className={`${styleLink(
            "users"
          )} w-full group/item inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
          aria-current="page"
        >
          <svg
            className={`${styleSvg("users")} -ml-0.5 mr-2 h-5 w-5`}
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M7 8a3 3 0 100-6 3 3 0 000 6zM14.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM1.615 16.428a1.224 1.224 0 01-.569-1.175 6.002 6.002 0 0111.908 0c.058.467-.172.92-.57 1.174A9.953 9.953 0 017 18a9.953 9.953 0 01-5.385-1.572zM14.5 16h-.106c.07-.297.088-.611.048-.933a7.47 7.47 0 00-1.588-3.755 4.502 4.502 0 015.874 2.636.818.818 0 01-.36.98A7.465 7.465 0 0114.5 16z"></path>
          </svg>
          <span>Users</span>
        </span>
      </li>
      <ACL showFor={[SUPERADMIN, ADMIN]}>
        <li>
          <span
            onClick={() => pageHandling(`modules`)}
            className={`${styleLink(
              "modules"
            )} w-full group/item inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
          >
            <svg
              className={`${styleSvg("modules")} -ml-0.5 mr-2 h-5 w-5`}
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M4 16.5v-13h-.25a.75.75 0 010-1.5h12.5a.75.75 0 010 1.5H16v13h.25a.75.75 0 010 1.5h-3.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75v2.5a.75.75 0 01-.75.75h-3.5a.75.75 0 010-1.5H4zm3-11a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM7.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM11 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm.5 3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>Module Access</span>
          </span>
        </li>
      </ACL>
      <li>
        <span
          onClick={() => pageHandling(`policy`)}
          className={`${styleLink(
            "policy"
          )} w-full group/item inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={`${styleSvg("policy")} -ml-0.5 mr-2 h-5 w-5`}
          >
            <path
              fill-rule="evenodd"
              d="M12.516 2.17a.75.75 0 00-1.032 0 11.209 11.209 0 01-7.877 3.08.75.75 0 00-.722.515A12.74 12.74 0 002.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 00.374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 00-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08zm3.094 8.016a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
              clip-rule="evenodd"
            />
          </svg>
          <span>Policy</span>
        </span>
      </li>
      {isZuperConnectEnabled &&
        (<ACL showFor={[SUPERADMIN, ADMIN]}>
          <li>
            <span
              onClick={() => pageHandling(`zuper_connect`)}
              className={`${styleLink(
                'zuper_connect'
              )} w-full group/item inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
            >
              <IoIosCall
                className={`${styleSvg('zuper_connect')} -ml-0.5 mr-2 h-5 w-5`}
              />
              <span>Zuper Connect</span>
            </span>
          </li>
        </ACL>)
      }
      {isZuperPayEnabled &&
        (<ACL showFor={[SUPERADMIN, ADMIN]}>
          <li>
            <span
              onClick={() => pageHandling(`zuper_pay`)}
              className={`${styleLink(
                'zuper_pay'
              )} w-full group/item inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
                className={`icon icon-tabler icons-tabler-outline icon-tabler-cash ${styleSvg('zuper_pay')} -ml-0.5 mr-2 h-5 w-5`}
              >
                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                <path d='M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3' />
                <path d='M7 9m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z' />
                <path d='M12 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
              </svg>
              <span>Zuper Pay</span>
            </span>
          </li>
        </ACL>)
      }
      {/* <li>
        <span
          onClick={() => pageHandling(`subscriptions`)}
          className={`${styleLink(
            "subscriptions"
          )} w-full group/item inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
        >
          <svg
            className={`${styleSvg("subscriptions")} -ml-0.5 mr-2 h-5 w-5`}
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M2.5 4A1.5 1.5 0 001 5.5V6h18v-.5A1.5 1.5 0 0017.5 4h-15zM19 8.5H1v6A1.5 1.5 0 002.5 16h15a1.5 1.5 0 001.5-1.5v-6zM3 13.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm4.75-.75a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span>Subscription</span>
        </span>
      </li> */}
      {/* <li>
        <span
          onClick={() => pageHandling(`integrations`)}
          className={`${styleLink(
            "integrations"
          )} w-full group/item inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
        >
          <svg
            className={`${styleSvg("integrations")}  -ml-0.5 mr-2.5 h-4 w-4`}
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 18 18"
          >
            <path d="M14.419 10.581a3.564 3.564 0 0 0-2.574 1.1l-4.756-2.49a3.54 3.54 0 0 0 .072-.71 3.55 3.55 0 0 0-.043-.428L11.67 6.1a3.56 3.56 0 1 0-.831-2.265c.006.143.02.286.043.428L6.33 6.218a3.573 3.573 0 1 0-.175 4.743l4.756 2.491a3.58 3.58 0 1 0 3.508-2.871Z" />
          </svg>
          <span className="flex grow w-full">
            Integrations{" "}
            <span className="ml-auto inline-flex items-center rounded-full bg-blue-50 ml-2 px-2 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
              {companyDetails?.count?.integrations || 0}
            </span>
          </span>
        </span>
      </li> */}
      <li>
        <span
          onClick={() => pageHandling(`credentials`)}
          className={`${styleLink(
            "credentials"
          )} w-full group/item inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={`${styleSvg("credentials")}  -ml-0.5 mr-2 h-5 w-5`}
          >
            <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
            <path
              fill-rule="evenodd"
              d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
              clip-rule="evenodd"
            />
          </svg>
          <span className="flex grow w-full">
            Credentials{" "}
            <span className="ml-auto inline-flex items-center rounded-full bg-blue-50 ml-2 px-2 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
              {companyDetails?.count?.credentials || 0}
            </span>
          </span>
        </span>
      </li>
      <li>
        <span
          onClick={() => pageHandling(`notes`)}
          className={`${styleLink(
            "notes"
          )} w-full group/item inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            className={`${styleSvg("notes")} -ml-0.5 mr-2 h-5 w-5`}
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z"
            />
          </svg>

          <span className="flex grow w-full">
            Notes{" "}
            <span className="ml-auto inline-flex items-center rounded-full bg-blue-50 ml-2 px-2 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
              {companyDetails?.count?.notes || 0}
            </span>
          </span>
        </span>
      </li>
      <li>
        <span
          onClick={() => pageHandling(`insights`)}
          className={`${styleLink(
            "insights"
          )} w-full group/item inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={`${styleSvg("insights")} -ml-0.5 mr-2 h-5 w-5`}
          >
            <path d="M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75zM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 01-1.875-1.875V8.625zM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 013 19.875v-6.75z" />
          </svg>
          <span>Insights</span>
        </span>
      </li>
      <li>
        <span
          onClick={() => pageHandling(`activity`)}
          className={`${styleLink(
            "activity"
          )} w-full group/item inline-flex items-center py-3 px-4 text-sm font-medium rounded-lg`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className={`${styleSvg("activity")} -ml-0.5 mr-2 h-5 w-5`}
          >
            <path
              fill-rule="evenodd"
              d="M14.615 1.595a.75.75 0 01.359.852L12.982 9.75h7.268a.75.75 0 01.548 1.262l-10.5 11.25a.75.75 0 01-1.272-.71l1.992-7.302H3.75a.75.75 0 01-.548-1.262l10.5-11.25a.75.75 0 01.913-.143z"
              clip-rule="evenodd"
            />
          </svg>
          <span>Activity</span>
        </span>
      </li>
    </ul>
  );
}

export default Sidebar;
